import type { ContactSheetData } from '@/entities/client';
import { useSheetStore } from '@/shared/stores/sheet-store';

// A plain function rather than a hook so it matches the contact profile's action bar directly, as
// `openEditClientProfileSheet` does for the client chart.
export function openEditContactProfileSheet(contact: ContactSheetData) {
    useSheetStore.getState().openSheet({
        type: 'clients/edit-contact-profile',
        label: 'Profile',
        data: { personId: contact.personId, name: contact.name },
    });
}
